export interface SubmitOptions {
  validateRequired?: boolean;
  skipValidation?: boolean;
}

export function parseSubmitOptions(data: unknown): SubmitOptions {
  if (data == null || data === '') {
    return {};
  }

  let parsed: unknown = data;
  if (typeof data === 'string') {
    try {
      parsed = JSON.parse(data);
    } catch {
      return {};
    }
  }

  if (typeof parsed !== 'object' || parsed === null) {
    return {};
  }

  const options = parsed as SubmitOptions;
  return {
    validateRequired: options.validateRequired,
    skipValidation: options.skipValidation,
  };
}

/** Whether required-field validation should run before submit. */
export function shouldValidateRequiredFields(data: unknown): boolean {
  const options = parseSubmitOptions(data);
  if (options.skipValidation === true || options.validateRequired === false) {
    return false;
  }
  if (options.validateRequired === true) {
    return true;
  }
  return true;
}
